import { gql } from "@apollo/client";

export default gql`
  mutation InviteGovernmentsToAddProduct($productId: ObjectId!, $governments: [ObjectId!]!) {
    inviteGovernmentsToAddProduct(productId: $productId, governments: $governments) {
      _id
      product {
        _id
        name
        slug
        logo
      }
      government {
        _id
        slug
        logo
        name
        budget
        currency
        isInnovator
        city {
          _id
          name
          population
          country
          countryName
        }
      }
      createdAt
    }
  }
`;
